<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction">
      <wt-form-table-list ref="declineTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
      </wt-form-table-list>
    </wt-form-table>
  </div>

</template>

<script>

export default {
  name: 'DeclineList',
  isAutoComponent: true,
  data() {
    return {
      imgUrl: window.wtConst.FILE_SERVER_URL,
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_DECLINE_LIST',
        formComponent: {
          list: { type: 'default', value: '/modules/integralRules/pointsRecordList' }
        },
        formInputsData: [
          { name: 'SN', key: 'name', value: this.$route.query.sn || '', type: 'text' }],
        formButtonsData: [{ name: '导出Excel',
          key: 'EXPORT',
          action: 'EXCEL',
          hidden: false,
          url: window.wtConst.BASE_API + '/modules/userIntegralDetails/userIntegralListImport',
          fileName: '投递量下滑箱体',
          permission: 'EXPORT' }],
        formTableData: [
          { name: '箱体名称', key: 'coverPath', type: 'text' },
          { name: 'SN', key: 'coverPath', type: 'text' },
          { name: '百分比下降(%)', key: 'coverPath', type: 'text' },
          { name: '总计', key: 'coverPath', type: 'text' },
          { name: '总计之前', key: 'coverPath', type: 'text' }],
        formTableButtonsData: [],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, buttonHidden: true, index: false }
      }
    }
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {
      if (data && data.item) {
        // if (data.item.action === 'VIEW' || data.item.action === 'EDIT') {
        // this.$store.dispatch('setLopperDetailData', data.row)
        // }
      }
    }
  }
}
</script>
